module.exports = __webpack_public_path__ + "static/media/logo-icon.71e72f4a.png";